//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  components: {},
  props: ["controlItem"],
  data() {
    return {};
  },
  created() {},

  methods: {
    $getComPage() {
      return this.$parent.$getComPage();
    },

    $getActionObj() {
      var page = this.$getComPage();
      if (!page) return null;
      var actionObj = page.$getActionObj();
      return actionObj;
    },

    async onButtonClick(buttonItem) {
      console.log("buttonItem", buttonItem);
      var $actionObj = this.$getActionObj();
      //var btnDataItem = buttonItem.DataItem;
      await this.$cmd.ExecuteCmd(buttonItem, $actionObj);
    }
  }
};
